import React, { useEffect, useRef } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import i18next from 'i18next';

import Icon from 'components/atoms/Icon';

export const onlyNumber = /^[0-9\b]+$/;

export function makeHeadData(data = [], addColumnList = new Map()) {
  const headCells = new Map();
  // 화면에서 추가하는 컬럼 json값 변환해서 반환해주는
  const returnAddColumJson = (columnData) => {
    const { id, label, align = 'center', makeRowFunc } = columnData;
    return {
      id,
      data: {
        id,
        label,
        align,
        displayFlag: true,
        className: `mb-${under2camel(id)}`,
        isAddColumn: true,
        makeRowFunc,
      },
    };
  };

  for (let i = 0; i < data.length; i++) {
    const head = data[i];
    const { id, label, orderFlag, type, format, displayFlag, calFlag } = head;
    const addColumn = addColumnList.get(i);
    if (typeof addColumn !== 'undefined') {
      const { id, data } = returnAddColumJson(addColumn);
      headCells.set(id, data);
    }

    // const align =
    //   type === 'number'
    //     ? 'right'
    //     : type === null || type === 'date'
    //     ? 'center'
    //     : 'left';

    const align = 'center';

    headCells.set(id, {
      id,
      label,
      align,
      orderFlag,
      type,
      format,
      displayFlag,
      calFlag,
      className: `mb-${under2camel(id)}`,
    });
  }

  // 화면에서 테이블 뒷컬럼에 추가해야 하는경우
  if (typeof addColumnList.get(-1) !== 'undefined') {
    for (let i = -1; i < addColumnList.size; i--) {
      const addColumn = addColumnList.get(i);

      if (typeof addColumn !== 'undefined') {
        const { id, data } = returnAddColumJson(addColumn);
        headCells.set(id, data);
      } else {
        // 더이상 없으므로 끝냄
        break;
      }
    }
  }
  return headCells;
}

/**
 * fetch header
 * @param {function} func fetch 수행할 api
 * @param {Map} addColumnList 화면에서 추가할 column list
 * @return {Promise}
 */
export function fetchHeader(func, addColumnList, uri) {
  // get table headers
  return new Promise((resolve, reject) => {
    func(uri)
      .then((response) => {
        const { data } = response.data;
        resolve(makeHeadData(data, addColumnList));
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/**
 * underbar -> camel
 * @param {string} str
 */
export function under2camel(str) {
  if (typeof str === 'string' && str.length > 0) {
    return str.toLowerCase().replace(/(_[a-z])/g, function (arg) {
      return arg.toUpperCase().replace('_', '');
    });
  }
}

/**
 * type, format 별 변환
 * @param {*} data
 * @param {*} type
 * @param {*} format
 */
export function makeRowColumn(data, type, format) {
  let result = data;

  if (type === 'number') {
    if (format !== '0.0%') {
      result = numeral(Number(data)).format(format);
    } else {
      if (!!Number(data)) {
        result = numeral(Number(data) + Number.EPSILON).format(format);
      } else {
        result = '0%';
      }
    }
  } else if (
    type === 'date' &&
    data !== 'total' &&
    data !== 'WEB' &&
    data !== 'MOBILE'
  ) {
    if (!isNaN(data)) {
      if (String(data).length === 8) {
        // 년월일으로만 넘어와야..
        result = moment(data, 'YYYYMMDD').format(format.toUpperCase());
      } else {
        result = moment(data).format(format.toUpperCase());
      }
    } else {
      result = moment(data).format(format.toUpperCase());
    }
  }

  return result;
}

/**
 * 응답받은 파일데이터 > 다운로드 처리
 * @param {JSON} response
 */
export function fileDownload(response) {
  const disposition = response.headers['content-disposition'];
  let fileName = 'download';
  if (disposition) {
    const marker = `UTF-8''`;
    const markerIdx = disposition.indexOf(marker);
    if (markerIdx !== -1) {
      fileName = decodeURI(
        disposition.slice(markerIdx + marker.length).replace(/;.*$/, '').trim()
      );
    } else {
      const match = disposition.match(/filename\s*=\s*["']?([^"';]+)["']?/i);
      if (match && match[1]) {
        fileName = decodeURI(match[1]);
      }
    }
  }

  const blob = new Blob([response.data], {
    type: 'application/octet-stream',
  });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // ie
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;

    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}

/**
 * talbe head 정보 사용할때 head 정보 바뀌어 undefined 에러 방지 위함
 * @param {Map} mapObj
 * @param {} key
 */
export function getHeadObj(mapObj, key) {
  const value = mapObj.get(key);
  return value ? value : {};
}

/**
 * 두자리수 월, 일 반환
 * @param {int} number
 * @param {boolean} isMonth
 */
export function twoDigits(number, isMonth = false) {
  if (isMonth) {
    number += 1;
  }
  if (number < 10) {
    return `0${number}`;
  }
  return number;
}

/**
 * moment 객체 값 숫자로 반환
 * @param {Object} momentObj
 */
export function getDate(momentObj) {
  const { years: sYears, months: sMonths, date: sDate } = momentObj.toObject();

  return `${sYears}${twoDigits(sMonths, true)}${twoDigits(sDate)}`;
}

/**
 * moment 객체 값 숫자로 반환
 * @param {Object} momentObj
 */
export function getMonthDate(momentObj) {
  const { years: sYears, months: sMonths } = momentObj.toObject();

  return `${sYears}${twoDigits(sMonths, true)}`;
}

/**
 * locaile 별 format 정보 return
 * @param {string} locale
 */
export function getFormat(locale) {
  return locale === 'ko'
    ? 'YYYY-MM-DD'
    : moment.localeData().longDateFormat('L');
}

export function toPercent(decimal, fixed = 0) {
  let tempFixed = fixed;
  if (decimal < 1) tempFixed = 1;
  return `${decimal.toFixed(tempFixed)}%`;
}

export function numberFormatter(decimal) {
  return numeral(decimal).format();
}

//
export function cenversionTpCode(code) {
  let resultCode;
  if (code !== '' && code === '01') {
    resultCode = '웹';
  } else if (code !== '' && code === '02') {
    resultCode = '모바일';
  }
  return resultCode;
}

/**
 * 그래프 데이터 만드는 공통 부분
 */
export const makeGraph = ({
  data,
  customize,
  primitiveData,
  referenceLine = {},
}) => {
  const { bar, line } = data;
  const dataKeys = {};
  const keyLabel = {};
  const tempGraphData = {};
  const graphData = [];
  let customizeData = {};
  const stackId = [];
  const referenceData = {};
  if (typeof bar !== 'undefined') {
    dataKeys['bar'] = bar;
  }

  if (typeof line !== 'undefined') {
    dataKeys['line'] = line;
  }

  if (typeof customize !== 'undefined') {
    customizeData = customize;
  }

  for (let kind in data) {
    if (data.hasOwnProperty(kind)) {
      const keys = data[kind];
      for (let i = 0; i < keys.length; i++) {
        const curKey = keys[i];
        if (kind === 'bar') {
          stackId.push(curKey);
        }
        if (!!primitiveData[curKey]) {
          keyLabel[curKey] = primitiveData[curKey].title;
          tempGraphData[curKey] = primitiveData[curKey].data;
        }
      }
    }
  }
  // graph data 담는 곳
  for (let key in tempGraphData) {
    if (tempGraphData.hasOwnProperty(key)) {
      // 평균 값 선 넣기 위해
      let average = false;
      let sum = 0;
      let count = 0;
      if (typeof referenceLine[key] !== 'undefined') {
        if (referenceLine[key].type === 'average') {
          average = true;
        }
      }

      for (let i = 0; i < tempGraphData[key].length; i++) {
        const curGraphData = tempGraphData[key][i];
        let { name, val } = curGraphData;

        if (
          typeof customize !== 'undefined' &&
          typeof customize[key] !== 'undefined'
        ) {
          if (customize[key].isPercent && val !== null) {
            val *= 100;
          }

          if (typeof customize[key].keyLabel !== 'undefined') {
            keyLabel[key] = customize[key].keyLabel;
          }
        }

        // 평균값 구하기
        if (average) {
          sum += Number(val);
          count++;
        }
        if (val === null) {
          graphData[i] = {
            ...graphData[i],
            name,
            [key]: 0,
          };
        } else {
          graphData[i] = {
            ...graphData[i],
            name,
            [key]: val,
          };
        }
      }

      if (average) {
        const { label, visibleValue = false, color } = referenceLine[key];
        const y = sum / count;

        referenceData[key] = {
          y,
          label: visibleValue
            ? `${label}(${numeral(y).format('0,00')})`
            : label,
          color: color,
        };
      }
    }
  }

  return {
    graphData,
    dataKeys,
    customizeData,
    keyLabel,
    stackId,
    referenceData,
  };
};

// 월 일 or 일 반환
export const makeLabel = (onlyDay, labelType) => (originalDate) => {
  let label;
  if (typeof originalDate === 'undefined') return '';

  let formatStr = 'YYYYMMDD';
  if (originalDate.length === 6) {
    formatStr = 'YYYYMM';
  }

  const dateObj = moment(originalDate, formatStr);
  const month = twoDigits(dateObj.month() + 1);
  const year = twoDigits(dateObj.year());
  const date = dateObj.date();
  // const day = dateObj.day();

  if (originalDate.length === 6) {
    label =
      labelType === 'YYYY'
        ? `${i18next.t(year + '년')}`
        : labelType === 'MM'
        ? `${i18next.t(month + '월')}`
        : `${i18next.t(year + '년')} ${i18next.t(month + '월')}`;
  } else {
    label =
      labelType === 'YYYYMMDD'
        ? `${i18next.t(year + '년')} ${i18next.t(month + '월')} ${i18next.t(
            date + '일'
          )}`
        : labelType === 'YYYYMM'
        ? `${i18next.t(year + '년')} ${i18next.t(month + '월')}`
        : labelType === 'MM'
        ? `${i18next.t(month + '월')}`
        : labelType === 'MMDD'
        ? `${i18next.t(month + '월')} ${twoDigits(date)}${i18next.t('일')}`
        : labelType === 'default'
        ? originalDate
        : `${twoDigits(date)}${i18next.t('일')}`;
  }
  return label;
};

/**
 * 그래프 툴팁 생성 함수
 * @param tickProps
 * @returns {JSX.Element}
 */
export const xAxisTick = (tickProps, labelType) => {
  const { x, y, payload } = tickProps;
  const { value } = payload;
  const length = String(value).length;
  let dateObj;
  let day;

  if (length === 4) {
    dateObj = moment(value, 'YYYYMM');
  } else {
    dateObj = moment(value, 'YYYYMMDD');
    day = dateObj.day();
  }

  const dayStr = makeLabel(true, labelType)(value);
  let fill = '';
  if (day === 0) {
    fill = '#dc5858';
  } else if (day === 6) {
    fill = '#4781cc';
  }

  return (
    <text x={x} y={y + 10} fill={length !== 8 ? '' : fill} textAnchor="middle">
      {labelType === 'default' ? value : dayStr}
    </text>
  );
};

/**
 * option 리스트 만들어주는 함수
 * @param {Array} data option list 만들 array
 * @param {string} optionLabelKey option에 나올 label key 값
 * @param {string} optionValueKey option value key 값
 */
export const makeOptionList = (data, optionLabelKey, optionValueKey) => {
  if (typeof data === 'undefined') {
    return [];
  }
  const result = [...data];
  const defaultOption = { [optionLabelKey]: '전체', [optionValueKey]: null };
  // 전체 라는 option 추가
  result.unshift(defaultOption);

  return result;
};

export const weeksConversion = (e) => {
  return e.toString().replace(/\B(?=(\d{1})+(?!\d))/g, ',');
};

// 날짜 색상 변환
export const dayColor = (date, type = 'date', format = 'MM-DD') => {
  let newDate = moment(date, 'YYYYMMDD').format('YYYY-MM-DD'.toUpperCase());
  let dayOfWeek = new Date(newDate).getDay();
  let resultComponent;
  let dayColor;
  if (dayOfWeek === 0) {
    dayColor = {
      color: 'red',
      margin: 0,
    };
  } else if (dayOfWeek === 6) {
    dayColor = {
      color: 'blue',
      margin: 0,
    };
  } else {
    dayColor = {
      margin: 0,
    };
  }
  resultComponent = (
    <span style={dayColor}>{makeRowColumn(date, type, format)}</span>
  );

  return resultComponent;
};

// 2단 테이블 헤더 데이터 생성
export const spanningTable = (type, headDatas) => {
  let resultData = [];
  let resultComponent;
  if (type === 'campaignLiveHead') {
    for (let data of headDatas.values()) {
      const { key, label } = data;
      resultData.push(
        <div
          key={key}
          style={{
            textOrientation: 'mixed',
            writingMode: 'vertical-lr',
          }}
        >
          {label}
        </div>
      );
    }
  } else if (type === 'campaignLive') {
    for (let data of headDatas.values()) {
      const { key, topValue, bottomValue } = data;
      resultData.push(
        <div key={key} style={{ width: 20 }}>
          {topValue ? <span style={{ color: 'red' }}>O</span> : 'X'}
          <br />
          {bottomValue ? <span style={{ color: 'red' }}>O</span> : 'X'}
        </div>
      );
    }
  } else {
    resultData = '데이터 없음';
  }

  resultComponent = resultData;

  return resultComponent;
};

// 2단 테이블 헤더 데이터 생성
export const nullConversion = (value) => {
  let convertedValue = value;

  if (String(value) === '00') {
    convertedValue = null;
  }
  return convertedValue;
};

/**
 * 배열의 오브젝트키를 변환 후 리턴
 * @example renameKeys(list,  ['key1', 'key2', 'key3'...]);
 * @param arrayObject
 * @param newKeys
 * @param index
 * @returns {Array}
 */
export const renameKeys = (arrayObject, newKeys, index = false) => {
  let newArray = [];
  arrayObject.forEach((obj, item) => {
    const keyValues = Object.keys(obj).map((key, i) => {
      return { [newKeys[i] || key]: obj[key] };
    });
    let id = index ? { ID: item } : {};
    newArray.push(Object.assign(id, ...keyValues));
  });
  return newArray;
};

/**
 * 필터 params converter
 * @example locationConverter(initParmas, ['pltfomTpCode', 'itlTpCode', ...], 'string');
 * @param data Object
 * @param keys Array
 * @returns {string}
 * @type {string}
 */
export const dataConverter = (data, keys = [], type = 'object') => {
  let locationStr = '';
  let convertData = {};
  let result;

  if (type === 'string') {
    for (const keysKey of Object.values(keys)) {
      if (
        typeof data[keysKey] !== 'undefined' &&
        data[keysKey] !== 'all' &&
        data[keysKey] !== ''
      ) {
        if (keysKey in data) {
          locationStr += '&' + keysKey + '=' + data[keysKey];
        }
      }
    }
    result = locationStr;
  } else if (type === 'object') {
    for (const keysKey of Object.values(keys)) {
      if (typeof data[keysKey] !== 'undefined') {
        if (keysKey in data) {
          convertData = {
            ...convertData,
            [keysKey]: data[keysKey],
          };
        }
      }
    }

    result = convertData;
  }

  return result;
};

export const conversionCamel = (string) => {
  let newString;
  newString = string
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
  return newString;
};

/*
url에 실어서 보낼 값을 변환시켜주는 함수
 */
export const converParameters = (params) => {
  let newParams = { ...params };
  let stringParams = '';
  let index = 0;

  for (let item in newParams) {
    if (item === 'url') {
      stringParams = newParams[item];
      delete newParams['url'];
      break;
    }
  }
  for (let item in newParams) {
    if (!!newParams[item]) {
      if (index === 0) {
        stringParams = stringParams + '?' + item + '=' + newParams[item];
      } else {
        stringParams = stringParams + '&' + item + '=' + newParams[item];
      }
      index = ++index;
    }
  }
  return stringParams;
};

export const getHost = (version = 'old') => {
  let { ancestorOrigins, origin } = window.location;
  let result = '';
  if (version === 'old') {
    const converterOrigin = ancestorOrigins[0];
    if (!!converterOrigin) {
      result = converterOrigin;
    } else {
      if (origin === 'http://admfe5.mobon.net') {
        result = 'https://stgims5.mobon.net';
      } else if (origin === 'https://admfe4.mobon.net') {
        result = 'https://stgims4.mobon.net';
      } else if (origin === 'https://admfe3.mobon.net') {
        result = 'https://stgims3.mobon.net';
      } else if (origin === 'https://admfe2.mobon.net') {
        result = 'https://stgims2.mobon.net';
      } else {
        result = 'https://ims.mobon.net';
      }
    }
  } else {
    result = origin;
  }

  return result;
};

/*
up down 만들어주는 함수
 */
export const converUpDown = (value, type, format, bracket = true) => {
  const color = value === 0 ? '#4d4f5c' : value > 0 ? '#4781cc' : '#dc5858';
  return (
    <span style={{ color: color }}>
      {color !== '#4d4f5c' && (
        <Icon
          icon={color === '#dc5858' ? 'faCaretDown' : 'faCaretUp'}
          color={color}
        />
      )}
      {bracket
        ? '(' + makeRowColumn(value, type, format) + ')'
        : makeRowColumn(value, type, format)}
    </span>
  );
};

/*
string 앞 0 자리 삭제해주는 공통함수
 */
export const replaceZero = (value) => {
  return value === 'all' ? 'ALL' : value.replace(/(^0+)/, '');
};

/*
number format 변환
 */
export const setNumberFormat = (value, type = 'integer', format = '0,0') => {
  // integer, percent,
  let newValue = value;
  let result = '0';
  if (type === 'percent') {
    newValue = newValue * 100;
  }
  if (!!value) {
    result = numeral(newValue).format(format);
  }
  if (type === 'percent') result = result + '%';
  return result;
};

/*
 * 디스플레이 1.0 형식으로 값 변환
 */
export const converDisplayValue = (targeting, prdtCode, tpCode, gb) => {
  let newValue = 'TOT';
  let newPrdtCode = '';
  let newTpCode = '';
  let targetingList = {};
  if (!!prdtCode) {
    targetingList = targeting.get(prdtCode);
    switch (prdtCode) {
      case '01': // 배너
        newPrdtCode = '';
        break;
      case '02': // 브랜드커버
        newPrdtCode = 'S';
        break;
      case '03': // 아이커버
        newPrdtCode = 'I';
        break;
      case '04': // 쇼콘
        newPrdtCode = '';
        if (tpCode === '02') {
          newValue = 'CA';
        } else if (tpCode === '09') {
          newValue = 'PE';
        }
        break;
      case '05': // 소셜링크
        newPrdtCode = 'K';
        break;
      case '06': // 플레이링크
        newPrdtCode = 'P';
        break;
      case '07': // 네이티브
        newPrdtCode = 'N';
        break;
      case '08': // 플러스콜
        newPrdtCode = 'W';
        break;
      default:
        newPrdtCode = '';
        break;
    }
    if (!!tpCode) {
      if (tpCode.split(',').length > 1) {
        newValue = 'TOT';
      } else {
        for (let item of targetingList['item']) {
          if (item['value'] === tpCode) {
            newTpCode = item['codeVal'];
            break;
          }
        }
        newValue = newPrdtCode + newTpCode;
      }
    }
  } else {
    newValue = 'TOT';
  }
  return newValue;
};

export const getDisplayNextToPrev = (targeting, allProductCodeList, gb) => {
  let result = {
    advrtsPrdtCode: undefined,
    advrtsTpCode: undefined,
  };
  if (gb === 'TOT') {
    delete result['advrtsPrdtCode'];
    delete result['advrtsTpCode'];
  } else {
    switch (gb) {
      case 'ALL':
        // 배너
        result['advrtsPrdtCode'] = '01';
        let stringTp = [];
        const tpList = targeting.get(result['advrtsPrdtCode']);
        for (let target of tpList['item']) {
          stringTp.push(target['value']);
        }
        result['advrtsTpCode'] = stringTp.join(',');
        break;
      case 'ALL2':
        // 아이커버
        result['advrtsPrdtCode'] = '03';
        break;
      case 'ALL3':
        // 브랜드커버
        result['advrtsPrdtCode'] = '02';
        break;
      case 'ALL6':
        // 소셜링크
        result['advrtsPrdtCode'] = '05';
        break;
      case 'ALL7':
        // 플레이링크
        result['advrtsPrdtCode'] = '06';
        break;
      case 'ALL8':
        // 네이티브
        result['advrtsPrdtCode'] = '07';
        break;
      case 'ALL9':
        // 플러스콜
        result['advrtsPrdtCode'] = '08';
        break;
      default:
        const cnt = gb.length;
        if (cnt === 3) {
          switch (gb.charAt(0)) {
            case 'I':
              result['advrtsPrdtCode'] = '03';
              break;
            case 'S':
              result['advrtsPrdtCode'] = '02';
              break;
            case 'P':
              result['advrtsPrdtCode'] = '05';
              break;
            case 'K':
              result['advrtsPrdtCode'] = '06';
              break;
            case 'N':
              result['advrtsPrdtCode'] = '07';
              break;
            case 'W':
              result['advrtsPrdtCode'] = '08';
              break;
            default:
              break;
          }
          allProductCodeList.forEach((target) => {
            if (target.codeVal === gb.substring(1)) {
              result['advrtsTpCode'] = target.value;
            }
          });
        } else if (cnt === 2) {
          result['advrtsPrdtCode'] = '01';
          allProductCodeList.forEach((target) => {
            if (target.codeVal === gb) {
              result['advrtsTpCode'] = target.value;
            }
          });
        } else {
          if (gb === 'ALL10') {
            result['advrtsPrdtCode'] = '09';
          } else {
            console.log(
              '%c 디스플레이 값 오류! ',
              'background: red; color: white; padding: 5px;'
            );
          }
        }
    }
    if (
      !!result['advrtsPrdtCode'] &&
      typeof result['advrtsTpCode'] === 'undefined'
    ) {
      let stringTp = [];
      const tpList = targeting.get(result['advrtsPrdtCode']);
      if (gb !== 'ALL10') {
        if (!!tpList) {
          for (let target of tpList['item']) {
            stringTp.push(target['value']);
          }
          result['advrtsTpCode'] = stringTp.join(',');
        } else {
          console.log(
            '%c tpList 오류! ',
            'background: red; color: white; padding: 5px;'
          );
        }
      }
    }
  }
  return result;
};

/*
 * 1.0 데이터를 받아서 2.0 으로 변경해주는 함수
 */
export const conversionParams = (targeting, uri, allProductCodeList) => {
  let newParams = {};
  let newItlTpCode = {
    '01': 1,
    '03': 1,
    '04': 1,
    '05': 1,
    '08': 1,
    '09': 1,
    '10': 1,
    '12': 1,
    '13': 1,
    '98': 1,
    '99': 1,
  };
  for (let key in uri) {
    if (key === 'gb' && !!uri['gb']) {
      const newGb = getDisplayNextToPrev(
        targeting,
        allProductCodeList,
        uri['gb']
      );
      newParams = { ...newParams, ...newGb };
    } else if (key === 'st_date' && !!uri['st_date']) {
      newParams['sDate'] = moment(uri['st_date']).format('YYYYMMDD');
    } else if (key === 'en_date' && !!uri['en_date']) {
      newParams['eDate'] = moment(uri['en_date']).format('YYYYMMDD');
    } else if (key === 'gb_web' && (!!uri['gb_web'] || uri['cateNum'])) {
      if (!!uri['cateNum']) {
        if (uri['cateNum'] === '10,13,24') {
          newParams['pltfomTpCode'] = '04';
        }
      } else {
        if (uri['gb_web'] < 10) {
          newParams['pltfomTpCode'] = '0' + uri['gb_web'];
        } else if (uri['gb_web'] >= 10) {
          newParams['pltfomTpCode'] = uri['gb_web'];
        } else {
          newParams['pltfomTpCode'] = 'all';
        }
      }
    } else if (key === 'cmno' && !!uri['cmno']) {
      newParams['contactNo'] = uri['cmno'];
    } else if (
      (key === 'timeLimitStart' && !!uri['timeLimitStart']) ||
      (key === 'timeLimitEnd' && !!uri['timeLimitEnd'])
    ) {
      if (key === 'timeLimitStart') {
        console.log('timeLimitStart');
        const start = Number(uri['timeLimitStart']);
        const end = Number(uri['timeLimitEnd']);
        let timeArray = [];
        for (let i = start; i <= end; ++i) {
          let timeString = '';
          if (i < 10) {
            timeString = '0' + i;
          } else {
            timeString = i;
          }
          timeArray.push(timeString);
        }
        newParams['statsHh'] = timeArray.toString();
      }
      // newParams['contactNo'] = uri['cmno'];
    } else if (key === 'mid' && !!uri['mid']) {
      newParams['mediaId'] = uri[key];
    } else if (key === 'media_id' && !!uri['media_id']) {
      newParams['mediaId'] = uri[key];
      console.log('media_id 있음!');
    } else if (key === 'mc' && !!uri['mc']) {
      newParams['mediaScriptNo'] = uri[key];
    } else if (
      (key === 'adExchange_include' && !!uri['adExchange_include']) ||
      (key === 'kakaoRTB_include' && !!uri['kakaoRTB_include']) ||
      (key === 'kakaoSearch' && !!uri['kakaoSearch'])
    ) {
      if (key === 'adExchange_include') {
        // itlTpCode : 99
        if (uri['adExchange_include'] === 'Y') {
        } else if (uri['adExchange_include'] === 'N') {
          delete newItlTpCode['98'];
          delete newItlTpCode['99'];
        }
      } else if (key === 'kakaoRTB_include') {
        console.log(
          'conversionParams kakaoRTB_include => ',
          uri['kakaoRTB_include']
        );
      } else if (key === 'kakaoSearch') {
        console.log('conversionParams kakaoSearch => ', uri['kakaoSearch']);
      }
      newParams['itlTpCode'] = Object.keys(newItlTpCode).toString();
    } else if (key === 'tp_code') {
      newParams['itlTpCode'] = uri[key];
    } else {
      if (!!uri[key]) {
        newParams[key] = uri[key];
      }
    }
  }
  return newParams;
};

export const converCalFlagData = (id, headsMap, row, tpsFlag = false) => {
  const headData = getHeadObj(headsMap, id);
  const tps = [
    'KL',
    'LC',
    'TC',
    'TV',
    'TR',
    'RE',
    'WC',
    'MC',
    'TP',
    'WP',
    'SP',
    'HP',
    'HR',
    'CR',
    'HV',
    'HE',
    'CW',
    'OS',
    'RC',
    'WV',
    'WR',
    'MV',
    'FR',
    'SR',
    'PR',
    'ST',
    'HU',
    'BP',
    'RM',
    'MT',
    'RU',
    'PU',
    'MU',
    'HM',
    'MO',
    'US',
    'UM',
    'GG',
    'GS',
    'MM',
    'IB',
    'KM',
    'IK',
    'MK',
    'CM',
    'MR',
    'AU',
    'SW',
    'PA',
    'AD',
    'PB',
    'CC',
    'SA',
    'SJ',
    'AT',
  ];
  let result = null;
  if (headData['calFlag'] !== false && headData['calFlag'] !== undefined) {
    const calcul = headData['calFlag']['calcul'];
    const columns = headData['calFlag']['columns'];
    const targetKey = id.split('_')[0];
    if (
      calcul === '{{column}}/{{column}}' ||
      calcul === '({{column}}/{{column}})'
    ) {
      if (!!row[columns[0]] && !!row[columns[1]]) {
        if (tpsFlag) {
          if (tps.includes(targetKey) && id.indexOf('PAR_EPRS_RATE') !== -1) {
            result = row[targetKey + '_' + columns[0]] / row[columns[1]];
          } else {
            result =
              row[targetKey + '_' + columns[0]] /
              row[targetKey + '_' + columns[1]];
          }
        } else {
          result = row[columns[0]] / row[columns[1]];
        }
      } else {
        console.log(id, ' : There is no data');
        result = row[id];
      }
    } else if (
      calcul === '{{column}}/{{column}}*1000' ||
      calcul === '({{column}}/{{column}})*1000'
    ) {
      if (!!row[columns[0]] && !!row[columns[1]]) {
        if (tps.includes(targetKey)) {
          result =
            (row[targetKey + '_' + columns[0]] /
              row[targetKey + '_' + columns[1]]) *
            1000;
        } else {
          result = (row[columns[0]] / row[columns[1]]) * 1000;
        }
      } else {
        console.log(id, ' : There is no data');
        result = row[id];
      }
    } else if (
      calcul === '(({{column}}/{{column}})-{{column}})/({{column}}/{{column}})'
    ) {
      if (
        !!row[columns[0]] &&
        !!row[columns[1]] &&
        !!row[columns[2]] &&
        !!row[columns[3]] &&
        !!row[columns[4]]
      ) {
        result =
          (row[columns[0]] / row[columns[1]] - row[columns[2]]) /
          (row[columns[3]] / row[columns[4]]);
      } else {
        console.log(id, ' : There is no data');
        result = row[id];
      }
    } else if (
      calcul === '({{column}}-{{column}})/{{column}}' ||
      calcul === '(({{column}}-{{column}})/{{column}})'
    ) {
      if (!!row[columns[0]] && !!row[columns[1]] && !!row[columns[2]]) {
        result = (row[columns[0]] - row[columns[1]]) / row[columns[2]];
      } else {
        console.log(id, ' : There is no data');
        result = row[id];
      }
    } else {
      console.log(id, '=> 계산법 없음');
      result = row[id];
    }
  } else {
    result = row[id];
  }
  if (isNaN(result) || result === Infinity) {
    result = 0;
  } else if (String(result).indexOf('e') !== -1) {
    result = result.toFixed(1);
  }
  return result;
};

/*
권한 체크
 */
export const menuAuthCheck = (grpNo, userId) => {
  let result = false;
  for (let user of grpNo) {
    if (user['USER_ID'] === userId) {
      result = true;
      break;
    }
  }
  return result;
};

export const commonGetParams = (params, newParams, name) => {
  let result = { ...newParams };
  if (name !== 'keyword' && name !== 'sort' && name !== 'order') {
    delete result['keyword'];
  }
  return result;
};

export const refreshParams = (prevParams, params) => {
  let result = false;
  const isChangeSort = prevParams.sort !== params.sort;
  const isChangeOrder = prevParams.order !== params.order;
  const isChangeKeyword = prevParams.keyword !== params.keyword;

  let prevP = { ...prevParams };
  let Ppp = { ...params };

  if (!isChangeSort && !isChangeOrder && !isChangeKeyword) {
    result = true;
  }

  for (let key in Ppp) {
    if (key !== 'sort' && key !== 'order' && key !== 'keyword') {
      if (Ppp[key] !== prevP[key]) {
        result = true;
        break;
      }
    }
  }
  // true를 리턴하면 새로고침
  return result;
};

export function usePrevState(state) {
  const ref = useRef(state);
  useEffect(() => {
    ref.current = state;
  }, [state]);
  return ref.current;
}

//날짜와 날짜사이 모든 날짜 배열변화
export const getDatesStartToLast = (startDate, lastDate, format) => {
  let newSdate = '';
  let newEdate = '';
  if (format === 'YYYYMMDD') {
    newSdate = startDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
    newEdate = lastDate.replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3');
  } else {
    newSdate = startDate;
    newEdate = lastDate;
  }
  let regex = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
  if (!(regex.test(newSdate) && regex.test(newEdate))) return 'Not Date Format';
  let result = [];
  let curDate = new Date(newSdate);
  while (curDate <= new Date(newEdate)) {
    let tempResult = curDate.toISOString().split('T')[0];

    if (format === 'YYYYMMDD') {
      result.push(tempResult.split('-').join(''));
    } else if (format === 'YYYY-MM-DD') {
      result.push(tempResult);
    }

    curDate.setDate(curDate.getDate() + 1);
  }
  return result;
};

// 클릭보드에 텍스트 복사
export const handleCopyClipBoard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    alert('URL이 복사되었습니다.');
  } catch (e) {
    alert('복사에 실패하였습니다.');
  }
};